import React from 'react';
import { BundleCard } from './BundleCard';
export function MiniBundles() {
  const productImage = 'https://cdn.magicpatterns.com/uploads/q5pbc7UPXB7yZsJKNiRqwd/LymphoriaX_(6).png';
  const bundles = [{
    qty: 1,
    price: '$700',
    original: '$700'
  }, {
    qty: 2,
    price: '$1,000',
    original: '$1,400',
    savings: 30
  }, {
    qty: 3,
    price: '$1,300',
    original: '$2,100',
    savings: 40,
    best: true
  }];
  return <div className="bg-white border-b border-gray-100 py-8 hidden md:block" data-id="element-1100"></div>;
}